if (!customElements.get('car-recommendations')) {
  customElements.define('car-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.loadRecommendations();
      }, {rootMargin: '300px'});
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    async loadRecommendations() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = html.querySelector('car-recommendations');
        // Keep the rendered collection fallback when Shopify has no suggestions yet.
        if (!this.isConnected || !replacement?.querySelector('[data-related-product]')) return;
        this.replaceChildren(...replacement.childNodes);
        this.dataset.source = replacement.dataset.source;
      } catch { /* The visible collection fallback remains usable offline. */ }
    }
  });
}
